import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  Grid, Typography, Paper, Table, TableHead,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'

import { withStyles } from '@material-ui/core/styles'

import { getPhrasesReport, setFromLink } from '../../../redux/actions'
import { setFilter, setReportsModal } from '../../../redux/actions/select'

import { defaultFilter } from '../../../utils/variables'

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

/**
 * Returns phrases report
 */
const PhrasesReport = (props) => {
  const { classes, page, rowsPerPage, phrasesReport, fromLink } = props

  const dispatch = useDispatch()

  const View = useSelector(state => state.userSettings.general.defaultView)
  const Filter = useSelector(state => state.selection.Filter)

  // const [page, setPage] = useState(0)
  // const [rowsPerPage, setRowsPerPage] = useState(25)

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, phrases.length - page * rowsPerPage)

  useEffect(() => {
    (async () => {
      await dispatch(getPhrasesReport(Filter))
        .catch((err) => {
          console.error(err)
        })
    }
    )()
  }, [dispatch, Filter])

  const handlePhraseFilter = (phrase) => {
    const filter = { ...defaultFilter, phrase: phrase.key }
    if (fromLink) {
      dispatch(setFromLink(false))
    }
    dispatch(setFilter(filter))
    dispatch(setReportsModal(false))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage)
  // }

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(event.target.value)
  //   setPage(0)
  // }

  return (
    <>
      <Grid container direction='column' justify='center' style={{ minWidth: '650px' }}>
        <Grid container direction='row'>
          <Grid container item direction='column' justify='flex-end' xs={12} className={classes.tableContainer}>
            <Paper elevation={2} className={classes.tablePaper}>
              {/* <h5 style={{ marginTop: '1rem', marginLeft: '1rem', fontWeight: 'bold', color: '#0000008A', fontSize: '2rem' }}>Captures by Phrase</h5> */}
              {/* <h5
                style={{ marginTop: '1rem', marginLeft: '1rem', fontWeight: 'bold', color: '#0000008A', fontSize: '1rem' }}
              >
                Number Of Reported Phrases: <span className='badge badge-primary my-auto mx-auto unselectable' style={{ fontSize: '1.3rem' }}>{totalProblems}</span>
              </h5> */}
              <Grid
                container
                direction='column'
                justify='center'
                className='px-3 w-100 py-3 mx-auto my-auto'
                spacing={2}
              >
                {
                  phrasesReport.length > 0
                    ? (
                      <>
                        {/* <Grid container justify='center' spacing={1}>
                          <TablePagination
                            component='div'
                            count={phrasesReport.length}
                            page={page}
                            onChangePage={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            rowsPerPageOptions={[100, 50, 25]}
                            color='secondary'
                          />
                        </Grid> */}
                        <TableContainer>
                          <Table className={classes.table} size='small' aria-label='users-table'>
                            <TableHead>
                              <TableRow>
                                <TableCell className={`${classes.tableHeadText} unselectable`}>Phrase</TableCell>
                                <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Captures</TableCell>
                                <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Total Severity</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {phrasesReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((phrase, index) => (
                                <StyledTableRow key={index}>
                                  <TableCell
                                    className={classes.tableText}
                                    component='th'
                                    scope='row'
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => { e.preventDefault(); handlePhraseFilter(phrase) }}
                                  >
                                    {phrase.key}
                                  </TableCell>
                                  <TableCell className={`${classes.tableText} unselectable`} align='right'>{phrase.doc_count}</TableCell>
                                  <TableCell className={`${classes.tableText} unselectable`} align='right'>{phrase.total_severity.value}</TableCell>
                                </StyledTableRow>
                              ))}
                              {/* {emptyRows > 0 &&
                                <TableRow>
                                  <TableCell />
                                </TableRow>} */}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : (
                      <>
                        <Grid item container direction='row' justify='center' alignItems='center'>
                          {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                          <Paper
                            className='mx-auto'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '10vh',
                              height: '20rem',
                              width: '30rem',
                              backgroundColor: '#F5F5F5'
                            }}
                          >
                            <Grid item container direction='column' xs={12}>
                              <Grid item container direction='row' justify='center'>
                                <AnnouncementIcon
                                  style={{
                                    fontSize: '4rem',
                                    color: 'grey',
                                    marginBottom: '1rem'
                                  }}
                                />
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography
                                  style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                >
                                  No Report Found
                                </Typography>
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography>Please try changing your selection in 'My Schools'</Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </>
                    )
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(PhrasesReport)
